import React, {useEffect, useState} from 'react';
import {debounce} from 'throttle-debounce';
import {colorThemeOptions, themeColorTitles} from '../models';
import {THEME_COLOR_ACCENT, THEME_COLOR_DARK, THEME_COLOR_LIGHT, THEME_DARK, THEME_LIGHT} from '../constants';
import {FormGroup, FormControl, ControlLabel, Button} from 'react-bootstrap';
import HelpHintButton from 'components/HelpHintButton';

const RegistrationThemeSettings = ({widgetTheme, eventTheme, onUpdate}) => {
    const [isThemeChanged, setIsThemeChanged] = useState(false);

    useEffect(() => {
        setDefaultWidgetTheme();
    }, []);
    
    function setDefaultWidgetTheme() {
        const {accentColor, backgroundColor, textColor} = eventTheme;
        
        const style = {
            [THEME_COLOR_ACCENT]: widgetTheme[THEME_COLOR_ACCENT] || accentColor,
            [THEME_COLOR_DARK]: widgetTheme[THEME_COLOR_DARK] || backgroundColor,
            [THEME_COLOR_LIGHT]: widgetTheme[THEME_COLOR_LIGHT] || textColor,
        };

        onUpdate('style', style);
        setIsThemeChanged(false);
    }

    function handleChangeTheme(value) {
        if (!value?.length) return;

        const themeColors = {
            ...widgetTheme,
            [THEME_COLOR_LIGHT]: value === THEME_DARK ? 'FFFFFF' : '16161B',
            [THEME_COLOR_DARK]: value === THEME_DARK ? '16161B' : 'FFFFFF',
        };

        onUpdate('style', themeColors);
        setIsThemeChanged(false);
    }

    const handleChangeColor = debounce(500, (key, value) => {
        onUpdate('style', {...widgetTheme, [key]: value.replace('#', '')});
        setIsThemeChanged(true);
    });

    const handleGetTheme = () => {
        return parseInt(widgetTheme[THEME_COLOR_DARK], 16) > parseInt(widgetTheme[THEME_COLOR_LIGHT], 16)
            ? THEME_LIGHT
            : THEME_DARK;
    }

    return widgetTheme ? (
        <FormGroup>
            <ControlLabel>
                <span>
                    Цветовая схема
                    <HelpHintButton>
                        Цвета элементов оформления виджета
                    </HelpHintButton>
                </span>
                { isThemeChanged &&
                    <Button
                        bsStyle="link"
                        bsSize="small"
                        onClick={setDefaultWidgetTheme}
                    >
                        Сбросить
                    </Button>
                }
            </ControlLabel>
            <FormGroup>
                <FormControl
                    value={handleGetTheme()}
                    componentClass="select"
                    name="playerTheme"
                    onChange={(e) => handleChangeTheme(e.target.value)}
                >
                    {
                        Object.entries(colorThemeOptions).map(([theme, name]) => 
                            (
                                <option
                                    key={theme}
                                    value={theme}
                                >
                                    {name}
                                </option>
                            )
                        )
                    }
                </FormControl>
            </FormGroup>
            {
                Object.entries(themeColorTitles).map(([key, value]) =>
                    <FormGroup
                        key={key}
                    >
                        <input
                            type="color"
                            value={`#${widgetTheme[key]}`}
                            onChange={(e) => handleChangeColor(key, e.target.value)}
                        />
                        <span>&nbsp;{value}</span>
                    </FormGroup>
                )
            }
        </FormGroup>
    ) : (<></>)
};

export default RegistrationThemeSettings;
